import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Owner } from 'src/app/classes/models/owner';

@Injectable({
  providedIn: 'root'
})
export class OwnerService {
  constructor(private http: HttpClient) {}

  saveOwner(Owner: Owner): Observable<any> {
    return this.http.post(`/api/v2/vendor/${Owner.VendorId}/owner`, Owner);
  }

  deleteOwner(OwnerId: number, VendorId: number): Observable<any> {
    return this.http.delete(
      `/api/v2/vendor/${VendorId}/owner/${OwnerId}/delete`
    );
  }

  getOwnerSSN(params: {
    OwnerId: number;
    VendorId: number;
  }): Observable<{ ssn: string }> {
    return this.http.get<{ ssn: string }>(
      `/api/v2/vendor/${params.VendorId}/owner/ssn`,
      { params: { OwnerId: params.OwnerId, VendorId: params.VendorId } }
    );
  }
}
